import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type LiveGlobalSearchQueryVariables = GraphQLTypes.Exact<{
  query: GraphQLTypes.Scalars['String']['input'];
}>;

export type LiveGlobalSearchQueryResult = { __typename?: 'Query' } & {
  liveViewsGlobalSearch: { __typename?: 'LiveViewsGlobalSearchResult' } & {
    searchResult: Array<
      { __typename?: 'SearchResult' } & Pick<GraphQLTypes.SearchResult, 'accountName' | 'description' | 'id' | 'type'> & {
          matchedFields: Array<
            { __typename?: 'MatchedField' } & Pick<GraphQLTypes.MatchedField, 'additionalInformation' | 'type' | 'value'>
          >;
        }
    >;
  };
};

export const LiveGlobalSearchDocument = gql`
  query liveGlobalSearch($query: String!) {
    liveViewsGlobalSearch(searchTerm: $query) {
      searchResult {
        accountName
        description
        id
        matchedFields {
          additionalInformation
          type
          value
        }
        type
      }
    }
  }
`;
